import { Service } from '@angular/core';

const KEY = 'scb.success';

/** Remembers (for this browser tab) that the customer confirmed their code, so `/success` can't be opened without it. */
@Service()
export class SuccessGate {
  open(): void {
    try {
      sessionStorage.setItem(KEY, '1');
    } catch {
      // storage blocked: the page just won't be reachable
    }
  }

  isOpen(): boolean {
    try {
      return sessionStorage.getItem(KEY) === '1';
    } catch {
      return false;
    }
  }
}
